<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <span>
        <span>{{ title }}</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">
            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> بابت : </span>
                    <span *ngIf="lang == 2"> Title : </span>
                    <input class='wh-input' formControlName="title" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="issue_date" class="wh-label">
                    <span>تاریخ صدور /دریافت: </span>
                    <div style="width:100%">
                        <input class="wh-input" matInput [matDatepicker]="picker" formControlName="issue_date"
                            [required]="required()" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="ref == 'financial'">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> نام طرف حساب : </span>
                    <span *ngIf="lang == 2"> User : </span>
                    <span (click)="reset_input(161)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="user_title" (click)="load_services(161) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="user" [hidden]="true" [required]="required()" readonly>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> بانک : </span>
                    <span *ngIf="lang == 2"> Bank : </span>
                    <span (click)="reset_input(178)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="bank_title" (click)="load_services(178) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="bank" [hidden]="true" [required]="required()" readonly>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="document_type != 1">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره حساب : </span>
                    <span *ngIf="lang == 2"> Cheque Number : </span>
                    <input class='wh-input' formControlName="account" autocomplete="off"
                        [required]="(type_task == 1 || type_task == 2) && document_type == 1">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="document_type != 2">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره حساب : </span>
                    <span *ngIf="lang == 2"> Account Number: </span>
                    <span (click)="reset_account()">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="account_title" (click)="select_account() "
                        [required]="(type_task == 1 || type_task == 2) && document_type == 2" readonly>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="document_type == 0">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> نام شعبه : </span>
                    <span *ngIf="lang == 2"> Branch name : </span>
                    <input class='wh-input' formControlName="branch_name" autocomplete="off"
                        [readonly]="document_type == 2" [disabled]="document_type == 2">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="document_type == 0">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> کد شعبه : </span>
                    <span *ngIf="lang == 2"> branch code : </span>
                    <input class='wh-input' formControlName="branch_code" autocomplete="off"
                        [readonly]="document_type == 2" [disabled]="document_type == 2">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="document_type != 1">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره چک : </span>
                    <span *ngIf="lang == 2"> Cheque Number : </span>
                    <input class='wh-input' formControlName="number" autocomplete="off" [required]="required()">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="document_type != 2">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره چک : </span>
                    <span *ngIf="lang == 2"> Account Number: </span>
                    <span (click)="reset_input(194)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="cheque_numbers_title" (click)="load_services(194)"
                        [required]="(type_task == 1 || type_task == 2) && document_type == 2" readonly>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="issue_date" class="wh-label">
                    <span>تاریخ سررسید: </span>
                    <div style="width:100%">
                        <input class="wh-input" [matDatepicker]="picker2" formControlName="due" [required]="required()"
                            autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="picker2" class="datepicker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </div>
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> مبلغ چک : </span>
                    <span *ngIf="lang == 2"> Price : </span>
                    <input class='wh-input' formControlName="price" autocomplete="off" currencyMask
                        [required]="required()">
                </label>
            </div>


            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="type_task == 1">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت چک : </span>
                    <span *ngIf="lang == 2"> Status : </span>
                    <span (click)="reset_input(190)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(190) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>